module.exports = __webpack_public_path__ + "img/gao7.8e79bd2a.png";